/*
 * @Description: 自定义滚动
 * @Author: F-Stone
 * @LastEditTime: 2025-08-12 16:03:16
 */
import Lenis from "lenis";

let lenis = null;

export default function (context, inject) {
  if (!process.client) return;

  const { app, $gsap, $ScrollTrigger } = context;

  if (!lenis) {
    lenis = new Lenis({ lerp: 0.12 });
    $gsap.ticker.add(function(time) {
      if (lenis) {
        lenis.raf(time * 1000);
      }
    });
    $gsap.ticker.lagSmoothing(0);
    lenis.on("scroll", function() {
      $ScrollTrigger.update();
    });
  }

  if (app.router) {
    app.router.afterEach(function() {
      if (lenis) {
        lenis.scrollTo(0, { immediate: true });
        lenis.resize();
      }
    });
  }

  inject("lenis", lenis);
}